/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AnexoDeProntuarioResponse,
  ArquivoDoProntuarioResponse,
  AtualizarProntuarioDto,
  AtualizarRascunhoDto,
  CancelarProntuarioDto,
  CriarProntuarioDto,
  CriarRascunhoDto,
  ErroResponse,
  ExameDoProntuarioResponse,
  ExameDoRascunhoDto,
  ListaDeAnexosResponse,
  ListaDeVersoesResponse,
  PaginaDeProntuariosResponse,
  ProntuarioResponse,
  ProntuariosControllerAdicionarAnexoBody,
  ProntuariosControllerAdicionarArquivoBody,
  ProntuariosControllerListarParams,
  RenomearArquivoDoRascunhoDto,
  UrlDoArquivoDoProntuarioResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getProntuariosControllerListarUrl = (params?: ProntuariosControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/prontuarios?${stringifiedParams}` : `/v1/prontuarios`
}

/**
 * @summary Lista os prontuários do ambiente, do atendimento mais recente
 */
export const prontuariosControllerListar = async (params?: ProntuariosControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeProntuariosResponse> => {

  return httpClient<PaginaDeProntuariosResponse>(getProntuariosControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProntuariosControllerListarQueryKey = (params?: ProntuariosControllerListarParams,) => {
    return [
    `/v1/prontuarios`, ...(params ? [params] : [])
    ] as const;
    }


export const getProntuariosControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof prontuariosControllerListar>>, TError = ErroResponse>(params?: ProntuariosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProntuariosControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof prontuariosControllerListar>>> = ({ signal }) => prontuariosControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProntuariosControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerListar>>>
export type ProntuariosControllerListarQueryError = ErroResponse


export function useProntuariosControllerListar<TData = Awaited<ReturnType<typeof prontuariosControllerListar>>, TError = ErroResponse>(
 params: undefined |  ProntuariosControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof prontuariosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof prontuariosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProntuariosControllerListar<TData = Awaited<ReturnType<typeof prontuariosControllerListar>>, TError = ErroResponse>(
 params?: ProntuariosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof prontuariosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof prontuariosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProntuariosControllerListar<TData = Awaited<ReturnType<typeof prontuariosControllerListar>>, TError = ErroResponse>(
 params?: ProntuariosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os prontuários do ambiente, do atendimento mais recente
 */

export function useProntuariosControllerListar<TData = Awaited<ReturnType<typeof prontuariosControllerListar>>, TError = ErroResponse>(
 params?: ProntuariosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProntuariosControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProntuariosControllerCriarUrl = () => {




  return `/v1/prontuarios`
}

/**
 * @summary Cria um prontuário JÁ REGISTRADO — que não se edita nem se exclui depois (o app usa esta). `atendidoEm` é quando o atendimento aconteceu. Aceita exames do paciente (`exameIds`); fotos/PDFs entram pelo rascunho.
 */
export const prontuariosControllerCriar = async (criarProntuarioDto: CriarProntuarioDto, options?: Parameters<typeof httpClient>[1]): Promise<ProntuarioResponse> => {

  return httpClient<ProntuarioResponse>(getProntuariosControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarProntuarioDto)
  }
);}





export const getProntuariosControllerCriarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerCriar>>, TError,{data: CriarProntuarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerCriar>>, TError,{data: CriarProntuarioDto}, TContext> => {

const mutationKey = ['prontuariosControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prontuariosControllerCriar>>, {data: CriarProntuarioDto}> = (props) => {
          const {data} = props ?? {};

          return  prontuariosControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProntuariosControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerCriar>>>
    export type ProntuariosControllerCriarMutationBody = CriarProntuarioDto
    export type ProntuariosControllerCriarMutationError = ErroResponse

    /**
 * @summary Cria um prontuário JÁ REGISTRADO — que não se edita nem se exclui depois (o app usa esta). `atendidoEm` é quando o atendimento aconteceu. Aceita exames do paciente (`exameIds`); fotos/PDFs entram pelo rascunho.
 */
export const useProntuariosControllerCriar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerCriar>>, TError,{data: CriarProntuarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prontuariosControllerCriar>>,
        TError,
        {data: CriarProntuarioDto},
        TContext
      > => {
      return useMutation(getProntuariosControllerCriarMutationOptions(options), queryClient);
    }
    export const getProntuariosControllerObterUrl = (id: string,) => {




  return `/v1/prontuarios/${id}`
}

/**
 * @summary Detalha um prontuário
 */
export const prontuariosControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ProntuarioResponse> => {

  return httpClient<ProntuarioResponse>(getProntuariosControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProntuariosControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/prontuarios/${id}`
    ] as const;
    }


export const getProntuariosControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof prontuariosControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProntuariosControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof prontuariosControllerObter>>> = ({ signal }) => prontuariosControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProntuariosControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerObter>>>
export type ProntuariosControllerObterQueryError = ErroResponse


export function useProntuariosControllerObter<TData = Awaited<ReturnType<typeof prontuariosControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof prontuariosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof prontuariosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProntuariosControllerObter<TData = Awaited<ReturnType<typeof prontuariosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof prontuariosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof prontuariosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProntuariosControllerObter<TData = Awaited<ReturnType<typeof prontuariosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um prontuário
 */

export function useProntuariosControllerObter<TData = Awaited<ReturnType<typeof prontuariosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProntuariosControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProntuariosControllerAtualizarUrl = (id: string,) => {




  return `/v1/prontuarios/${id}`
}

/**
 * @summary DESATIVADO (item 16): prontuário não se edita. Responde 409 `PRONTUARIO_IMUTAVEL` — use um anexo (ou, no rascunho, PATCH .../rascunho).
 */
export const prontuariosControllerAtualizar = async (id: string,
    atualizarProntuarioDto: AtualizarProntuarioDto, options?: Parameters<typeof httpClient>[1]): Promise<unknown> => {

  return httpClient<unknown>(getProntuariosControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarProntuarioDto)
  }
);}





export const getProntuariosControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAtualizar>>, TError,{id: string;data: AtualizarProntuarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAtualizar>>, TError,{id: string;data: AtualizarProntuarioDto}, TContext> => {

const mutationKey = ['prontuariosControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prontuariosControllerAtualizar>>, {id: string;data: AtualizarProntuarioDto}> = (props) => {
          const {id,data} = props ?? {};

          return  prontuariosControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProntuariosControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerAtualizar>>>
    export type ProntuariosControllerAtualizarMutationBody = AtualizarProntuarioDto
    export type ProntuariosControllerAtualizarMutationError = ErroResponse

    /**
 * @summary DESATIVADO (item 16): prontuário não se edita. Responde 409 `PRONTUARIO_IMUTAVEL` — use um anexo (ou, no rascunho, PATCH .../rascunho).
 */
export const useProntuariosControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAtualizar>>, TError,{id: string;data: AtualizarProntuarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prontuariosControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarProntuarioDto},
        TContext
      > => {
      return useMutation(getProntuariosControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getProntuariosControllerExcluirUrl = (id: string,) => {




  return `/v1/prontuarios/${id}`
}

/**
 * @summary DESATIVADO (item 16): prontuário não se exclui. Responde 409 `PRONTUARIO_IMUTAVEL` — use cancelar.
 */
export const prontuariosControllerExcluir = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<unknown> => {

  return httpClient<unknown>(getProntuariosControllerExcluirUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getProntuariosControllerExcluirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerExcluir>>, TError,{id: string}, TContext> => {

const mutationKey = ['prontuariosControllerExcluir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prontuariosControllerExcluir>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  prontuariosControllerExcluir(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProntuariosControllerExcluirMutationResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerExcluir>>>

    export type ProntuariosControllerExcluirMutationError = ErroResponse

    /**
 * @summary DESATIVADO (item 16): prontuário não se exclui. Responde 409 `PRONTUARIO_IMUTAVEL` — use cancelar.
 */
export const useProntuariosControllerExcluir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prontuariosControllerExcluir>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getProntuariosControllerExcluirMutationOptions(options), queryClient);
    }
    export const getProntuariosControllerVersoesUrl = (id: string,) => {




  return `/v1/prontuarios/${id}/versoes`
}

/**
 * @summary Trilha das edições de ANTES do item 16 (hoje o prontuário não se edita). Cada entrada é o conteúdo anterior.
 */
export const prontuariosControllerVersoes = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ListaDeVersoesResponse> => {

  return httpClient<ListaDeVersoesResponse>(getProntuariosControllerVersoesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProntuariosControllerVersoesQueryKey = (id: string,) => {
    return [
    `/v1/prontuarios/${id}/versoes`
    ] as const;
    }


export const getProntuariosControllerVersoesQueryOptions = <TData = Awaited<ReturnType<typeof prontuariosControllerVersoes>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerVersoes>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProntuariosControllerVersoesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof prontuariosControllerVersoes>>> = ({ signal }) => prontuariosControllerVersoes(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerVersoes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProntuariosControllerVersoesQueryResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerVersoes>>>
export type ProntuariosControllerVersoesQueryError = unknown


export function useProntuariosControllerVersoes<TData = Awaited<ReturnType<typeof prontuariosControllerVersoes>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerVersoes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof prontuariosControllerVersoes>>,
          TError,
          Awaited<ReturnType<typeof prontuariosControllerVersoes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProntuariosControllerVersoes<TData = Awaited<ReturnType<typeof prontuariosControllerVersoes>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerVersoes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof prontuariosControllerVersoes>>,
          TError,
          Awaited<ReturnType<typeof prontuariosControllerVersoes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProntuariosControllerVersoes<TData = Awaited<ReturnType<typeof prontuariosControllerVersoes>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerVersoes>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Trilha das edições de ANTES do item 16 (hoje o prontuário não se edita). Cada entrada é o conteúdo anterior.
 */

export function useProntuariosControllerVersoes<TData = Awaited<ReturnType<typeof prontuariosControllerVersoes>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerVersoes>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProntuariosControllerVersoesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProntuariosControllerCriarRascunhoUrl = () => {




  return `/v1/prontuarios/rascunho`
}

/**
 * @summary Abre um RASCUNHO ("Novo prontuário" na web): existe desde já para receber fotos/PDFs, exames e a gravação; salva sozinho (PATCH .../rascunho) e só vale depois de registrado. Não expira.
 */
export const prontuariosControllerCriarRascunho = async (criarRascunhoDto: CriarRascunhoDto, options?: Parameters<typeof httpClient>[1]): Promise<ProntuarioResponse> => {

  return httpClient<ProntuarioResponse>(getProntuariosControllerCriarRascunhoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarRascunhoDto)
  }
);}





export const getProntuariosControllerCriarRascunhoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerCriarRascunho>>, TError,{data: CriarRascunhoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerCriarRascunho>>, TError,{data: CriarRascunhoDto}, TContext> => {

const mutationKey = ['prontuariosControllerCriarRascunho'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prontuariosControllerCriarRascunho>>, {data: CriarRascunhoDto}> = (props) => {
          const {data} = props ?? {};

          return  prontuariosControllerCriarRascunho(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProntuariosControllerCriarRascunhoMutationResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerCriarRascunho>>>
    export type ProntuariosControllerCriarRascunhoMutationBody = CriarRascunhoDto
    export type ProntuariosControllerCriarRascunhoMutationError = ErroResponse

    /**
 * @summary Abre um RASCUNHO ("Novo prontuário" na web): existe desde já para receber fotos/PDFs, exames e a gravação; salva sozinho (PATCH .../rascunho) e só vale depois de registrado. Não expira.
 */
export const useProntuariosControllerCriarRascunho = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerCriarRascunho>>, TError,{data: CriarRascunhoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prontuariosControllerCriarRascunho>>,
        TError,
        {data: CriarRascunhoDto},
        TContext
      > => {
      return useMutation(getProntuariosControllerCriarRascunhoMutationOptions(options), queryClient);
    }
    export const getProntuariosControllerAtualizarRascunhoUrl = (id: string,) => {




  return `/v1/prontuarios/${id}/rascunho`
}

/**
 * @summary Salvamento automático do rascunho. Registrado, responde 409.
 */
export const prontuariosControllerAtualizarRascunho = async (id: string,
    atualizarRascunhoDto: AtualizarRascunhoDto, options?: Parameters<typeof httpClient>[1]): Promise<ProntuarioResponse> => {

  return httpClient<ProntuarioResponse>(getProntuariosControllerAtualizarRascunhoUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarRascunhoDto)
  }
);}





export const getProntuariosControllerAtualizarRascunhoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAtualizarRascunho>>, TError,{id: string;data: AtualizarRascunhoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAtualizarRascunho>>, TError,{id: string;data: AtualizarRascunhoDto}, TContext> => {

const mutationKey = ['prontuariosControllerAtualizarRascunho'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prontuariosControllerAtualizarRascunho>>, {id: string;data: AtualizarRascunhoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  prontuariosControllerAtualizarRascunho(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProntuariosControllerAtualizarRascunhoMutationResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerAtualizarRascunho>>>
    export type ProntuariosControllerAtualizarRascunhoMutationBody = AtualizarRascunhoDto
    export type ProntuariosControllerAtualizarRascunhoMutationError = ErroResponse

    /**
 * @summary Salvamento automático do rascunho. Registrado, responde 409.
 */
export const useProntuariosControllerAtualizarRascunho = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAtualizarRascunho>>, TError,{id: string;data: AtualizarRascunhoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prontuariosControllerAtualizarRascunho>>,
        TError,
        {id: string;data: AtualizarRascunhoDto},
        TContext
      > => {
      return useMutation(getProntuariosControllerAtualizarRascunhoMutationOptions(options), queryClient);
    }
    export const getProntuariosControllerDescartarRascunhoUrl = (id: string,) => {




  return `/v1/prontuarios/${id}/rascunho`
}

/**
 * @summary Descarta o rascunho de vez, com fotos/PDFs e gravação. Registrado, responde 409.
 */
export const prontuariosControllerDescartarRascunho = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getProntuariosControllerDescartarRascunhoUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getProntuariosControllerDescartarRascunhoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerDescartarRascunho>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerDescartarRascunho>>, TError,{id: string}, TContext> => {

const mutationKey = ['prontuariosControllerDescartarRascunho'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prontuariosControllerDescartarRascunho>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  prontuariosControllerDescartarRascunho(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProntuariosControllerDescartarRascunhoMutationResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerDescartarRascunho>>>

    export type ProntuariosControllerDescartarRascunhoMutationError = ErroResponse

    /**
 * @summary Descarta o rascunho de vez, com fotos/PDFs e gravação. Registrado, responde 409.
 */
export const useProntuariosControllerDescartarRascunho = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerDescartarRascunho>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prontuariosControllerDescartarRascunho>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getProntuariosControllerDescartarRascunhoMutationOptions(options), queryClient);
    }
    export const getProntuariosControllerRegistrarUrl = (id: string,) => {




  return `/v1/prontuarios/${id}/registrar`
}

/**
 * @summary Registra o rascunho com o formulário como está na tela — daqui em diante não muda mais. Exige o texto; gravação ainda em andamento bloqueia.
 */
export const prontuariosControllerRegistrar = async (id: string,
    atualizarRascunhoDto: AtualizarRascunhoDto, options?: Parameters<typeof httpClient>[1]): Promise<ProntuarioResponse> => {

  return httpClient<ProntuarioResponse>(getProntuariosControllerRegistrarUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarRascunhoDto)
  }
);}





export const getProntuariosControllerRegistrarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerRegistrar>>, TError,{id: string;data: AtualizarRascunhoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerRegistrar>>, TError,{id: string;data: AtualizarRascunhoDto}, TContext> => {

const mutationKey = ['prontuariosControllerRegistrar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prontuariosControllerRegistrar>>, {id: string;data: AtualizarRascunhoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  prontuariosControllerRegistrar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProntuariosControllerRegistrarMutationResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerRegistrar>>>
    export type ProntuariosControllerRegistrarMutationBody = AtualizarRascunhoDto
    export type ProntuariosControllerRegistrarMutationError = ErroResponse

    /**
 * @summary Registra o rascunho com o formulário como está na tela — daqui em diante não muda mais. Exige o texto; gravação ainda em andamento bloqueia.
 */
export const useProntuariosControllerRegistrar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerRegistrar>>, TError,{id: string;data: AtualizarRascunhoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prontuariosControllerRegistrar>>,
        TError,
        {id: string;data: AtualizarRascunhoDto},
        TContext
      > => {
      return useMutation(getProntuariosControllerRegistrarMutationOptions(options), queryClient);
    }
    export const getProntuariosControllerAdicionarArquivoUrl = (id: string,) => {




  return `/v1/prontuarios/${id}/arquivos`
}

/**
 * @summary Foto/PDF no rascunho — sobe ao escolher, já vinculada, com título.
 */
export const prontuariosControllerAdicionarArquivo = async (id: string,
    prontuariosControllerAdicionarArquivoBody: ProntuariosControllerAdicionarArquivoBody, options?: Parameters<typeof httpClient>[1]): Promise<ArquivoDoProntuarioResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, prontuariosControllerAdicionarArquivoBody.arquivo);
formData.append(`titulo`, prontuariosControllerAdicionarArquivoBody.titulo);

  return httpClient<ArquivoDoProntuarioResponse>(getProntuariosControllerAdicionarArquivoUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getProntuariosControllerAdicionarArquivoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAdicionarArquivo>>, TError,{id: string;data: ProntuariosControllerAdicionarArquivoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAdicionarArquivo>>, TError,{id: string;data: ProntuariosControllerAdicionarArquivoBody}, TContext> => {

const mutationKey = ['prontuariosControllerAdicionarArquivo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prontuariosControllerAdicionarArquivo>>, {id: string;data: ProntuariosControllerAdicionarArquivoBody}> = (props) => {
          const {id,data} = props ?? {};

          return  prontuariosControllerAdicionarArquivo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProntuariosControllerAdicionarArquivoMutationResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerAdicionarArquivo>>>
    export type ProntuariosControllerAdicionarArquivoMutationBody = ProntuariosControllerAdicionarArquivoBody
    export type ProntuariosControllerAdicionarArquivoMutationError = ErroResponse

    /**
 * @summary Foto/PDF no rascunho — sobe ao escolher, já vinculada, com título.
 */
export const useProntuariosControllerAdicionarArquivo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAdicionarArquivo>>, TError,{id: string;data: ProntuariosControllerAdicionarArquivoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prontuariosControllerAdicionarArquivo>>,
        TError,
        {id: string;data: ProntuariosControllerAdicionarArquivoBody},
        TContext
      > => {
      return useMutation(getProntuariosControllerAdicionarArquivoMutationOptions(options), queryClient);
    }
    export const getProntuariosControllerRenomearArquivoUrl = (id: string,
    arquivoId: string,) => {




  return `/v1/prontuarios/${id}/arquivos/${arquivoId}`
}

/**
 * @summary Renomeia uma foto/PDF do rascunho.
 */
export const prontuariosControllerRenomearArquivo = async (id: string,
    arquivoId: string,
    renomearArquivoDoRascunhoDto: RenomearArquivoDoRascunhoDto, options?: Parameters<typeof httpClient>[1]): Promise<ArquivoDoProntuarioResponse> => {

  return httpClient<ArquivoDoProntuarioResponse>(getProntuariosControllerRenomearArquivoUrl(id,arquivoId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(renomearArquivoDoRascunhoDto)
  }
);}





export const getProntuariosControllerRenomearArquivoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerRenomearArquivo>>, TError,{id: string;arquivoId: string;data: RenomearArquivoDoRascunhoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerRenomearArquivo>>, TError,{id: string;arquivoId: string;data: RenomearArquivoDoRascunhoDto}, TContext> => {

const mutationKey = ['prontuariosControllerRenomearArquivo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prontuariosControllerRenomearArquivo>>, {id: string;arquivoId: string;data: RenomearArquivoDoRascunhoDto}> = (props) => {
          const {id,arquivoId,data} = props ?? {};

          return  prontuariosControllerRenomearArquivo(id,arquivoId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProntuariosControllerRenomearArquivoMutationResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerRenomearArquivo>>>
    export type ProntuariosControllerRenomearArquivoMutationBody = RenomearArquivoDoRascunhoDto
    export type ProntuariosControllerRenomearArquivoMutationError = ErroResponse

    /**
 * @summary Renomeia uma foto/PDF do rascunho.
 */
export const useProntuariosControllerRenomearArquivo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerRenomearArquivo>>, TError,{id: string;arquivoId: string;data: RenomearArquivoDoRascunhoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prontuariosControllerRenomearArquivo>>,
        TError,
        {id: string;arquivoId: string;data: RenomearArquivoDoRascunhoDto},
        TContext
      > => {
      return useMutation(getProntuariosControllerRenomearArquivoMutationOptions(options), queryClient);
    }
    export const getProntuariosControllerRemoverArquivoUrl = (id: string,
    arquivoId: string,) => {




  return `/v1/prontuarios/${id}/arquivos/${arquivoId}`
}

/**
 * @summary Tira uma foto/PDF do rascunho (e apaga o arquivo).
 */
export const prontuariosControllerRemoverArquivo = async (id: string,
    arquivoId: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getProntuariosControllerRemoverArquivoUrl(id,arquivoId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getProntuariosControllerRemoverArquivoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerRemoverArquivo>>, TError,{id: string;arquivoId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerRemoverArquivo>>, TError,{id: string;arquivoId: string}, TContext> => {

const mutationKey = ['prontuariosControllerRemoverArquivo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prontuariosControllerRemoverArquivo>>, {id: string;arquivoId: string}> = (props) => {
          const {id,arquivoId} = props ?? {};

          return  prontuariosControllerRemoverArquivo(id,arquivoId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProntuariosControllerRemoverArquivoMutationResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerRemoverArquivo>>>

    export type ProntuariosControllerRemoverArquivoMutationError = ErroResponse

    /**
 * @summary Tira uma foto/PDF do rascunho (e apaga o arquivo).
 */
export const useProntuariosControllerRemoverArquivo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerRemoverArquivo>>, TError,{id: string;arquivoId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prontuariosControllerRemoverArquivo>>,
        TError,
        {id: string;arquivoId: string},
        TContext
      > => {
      return useMutation(getProntuariosControllerRemoverArquivoMutationOptions(options), queryClient);
    }
    export const getProntuariosControllerUrlDoArquivoUrl = (id: string,
    arquivoId: string,) => {




  return `/v1/prontuarios/${id}/arquivos/${arquivoId}`
}

/**
 * @summary URL assinada de uma foto/PDF deste prontuário (do cadastro ou de um anexo)
 */
export const prontuariosControllerUrlDoArquivo = async (id: string,
    arquivoId: string, options?: Parameters<typeof httpClient>[1]): Promise<UrlDoArquivoDoProntuarioResponse> => {

  return httpClient<UrlDoArquivoDoProntuarioResponse>(getProntuariosControllerUrlDoArquivoUrl(id,arquivoId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProntuariosControllerUrlDoArquivoQueryKey = (id: string,
    arquivoId: string,) => {
    return [
    `/v1/prontuarios/${id}/arquivos/${arquivoId}`
    ] as const;
    }


export const getProntuariosControllerUrlDoArquivoQueryOptions = <TData = Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>, TError = ErroResponse>(id: string,
    arquivoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProntuariosControllerUrlDoArquivoQueryKey(id,arquivoId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>> = ({ signal }) => prontuariosControllerUrlDoArquivo(id,arquivoId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && arquivoId !== null && arquivoId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProntuariosControllerUrlDoArquivoQueryResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>>
export type ProntuariosControllerUrlDoArquivoQueryError = ErroResponse


export function useProntuariosControllerUrlDoArquivo<TData = Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>, TError = ErroResponse>(
 id: string,
    arquivoId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>,
          TError,
          Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProntuariosControllerUrlDoArquivo<TData = Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>, TError = ErroResponse>(
 id: string,
    arquivoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>,
          TError,
          Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProntuariosControllerUrlDoArquivo<TData = Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>, TError = ErroResponse>(
 id: string,
    arquivoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary URL assinada de uma foto/PDF deste prontuário (do cadastro ou de um anexo)
 */

export function useProntuariosControllerUrlDoArquivo<TData = Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>, TError = ErroResponse>(
 id: string,
    arquivoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerUrlDoArquivo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProntuariosControllerUrlDoArquivoQueryOptions(id,arquivoId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProntuariosControllerAdicionarExameUrl = (id: string,) => {




  return `/v1/prontuarios/${id}/exames`
}

/**
 * @summary Vincula um exame do paciente ao rascunho.
 */
export const prontuariosControllerAdicionarExame = async (id: string,
    exameDoRascunhoDto: ExameDoRascunhoDto, options?: Parameters<typeof httpClient>[1]): Promise<ExameDoProntuarioResponse> => {

  return httpClient<ExameDoProntuarioResponse>(getProntuariosControllerAdicionarExameUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(exameDoRascunhoDto)
  }
);}





export const getProntuariosControllerAdicionarExameMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAdicionarExame>>, TError,{id: string;data: ExameDoRascunhoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAdicionarExame>>, TError,{id: string;data: ExameDoRascunhoDto}, TContext> => {

const mutationKey = ['prontuariosControllerAdicionarExame'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prontuariosControllerAdicionarExame>>, {id: string;data: ExameDoRascunhoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  prontuariosControllerAdicionarExame(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProntuariosControllerAdicionarExameMutationResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerAdicionarExame>>>
    export type ProntuariosControllerAdicionarExameMutationBody = ExameDoRascunhoDto
    export type ProntuariosControllerAdicionarExameMutationError = ErroResponse

    /**
 * @summary Vincula um exame do paciente ao rascunho.
 */
export const useProntuariosControllerAdicionarExame = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAdicionarExame>>, TError,{id: string;data: ExameDoRascunhoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prontuariosControllerAdicionarExame>>,
        TError,
        {id: string;data: ExameDoRascunhoDto},
        TContext
      > => {
      return useMutation(getProntuariosControllerAdicionarExameMutationOptions(options), queryClient);
    }
    export const getProntuariosControllerRemoverExameUrl = (id: string,
    exameId: string,) => {




  return `/v1/prontuarios/${id}/exames/${exameId}`
}

/**
 * @summary Desvincula um exame do rascunho (o exame continua existindo).
 */
export const prontuariosControllerRemoverExame = async (id: string,
    exameId: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getProntuariosControllerRemoverExameUrl(id,exameId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getProntuariosControllerRemoverExameMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerRemoverExame>>, TError,{id: string;exameId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerRemoverExame>>, TError,{id: string;exameId: string}, TContext> => {

const mutationKey = ['prontuariosControllerRemoverExame'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prontuariosControllerRemoverExame>>, {id: string;exameId: string}> = (props) => {
          const {id,exameId} = props ?? {};

          return  prontuariosControllerRemoverExame(id,exameId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProntuariosControllerRemoverExameMutationResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerRemoverExame>>>

    export type ProntuariosControllerRemoverExameMutationError = ErroResponse

    /**
 * @summary Desvincula um exame do rascunho (o exame continua existindo).
 */
export const useProntuariosControllerRemoverExame = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerRemoverExame>>, TError,{id: string;exameId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prontuariosControllerRemoverExame>>,
        TError,
        {id: string;exameId: string},
        TContext
      > => {
      return useMutation(getProntuariosControllerRemoverExameMutationOptions(options), queryClient);
    }
    export const getProntuariosControllerAssinarUrl = (id: string,) => {




  return `/v1/prontuarios/${id}/assinar`
}

/**
 * @summary Assina o prontuário. Anexos continuam entrando depois.
 */
export const prontuariosControllerAssinar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ProntuarioResponse> => {

  return httpClient<ProntuarioResponse>(getProntuariosControllerAssinarUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getProntuariosControllerAssinarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAssinar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAssinar>>, TError,{id: string}, TContext> => {

const mutationKey = ['prontuariosControllerAssinar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prontuariosControllerAssinar>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  prontuariosControllerAssinar(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProntuariosControllerAssinarMutationResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerAssinar>>>

    export type ProntuariosControllerAssinarMutationError = ErroResponse

    /**
 * @summary Assina o prontuário. Anexos continuam entrando depois.
 */
export const useProntuariosControllerAssinar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAssinar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prontuariosControllerAssinar>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getProntuariosControllerAssinarMutationOptions(options), queryClient);
    }
    export const getProntuariosControllerCancelarUrl = (id: string,) => {




  return `/v1/prontuarios/${id}/cancelar`
}

/**
 * @summary Cancela o prontuário (engano: paciente errado, duplicado). Continua visível, com motivo, autor e data; deixa de aceitar anexo e não conta mais como o mais recente.
 */
export const prontuariosControllerCancelar = async (id: string,
    cancelarProntuarioDto: CancelarProntuarioDto, options?: Parameters<typeof httpClient>[1]): Promise<ProntuarioResponse> => {

  return httpClient<ProntuarioResponse>(getProntuariosControllerCancelarUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelarProntuarioDto)
  }
);}





export const getProntuariosControllerCancelarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerCancelar>>, TError,{id: string;data: CancelarProntuarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerCancelar>>, TError,{id: string;data: CancelarProntuarioDto}, TContext> => {

const mutationKey = ['prontuariosControllerCancelar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prontuariosControllerCancelar>>, {id: string;data: CancelarProntuarioDto}> = (props) => {
          const {id,data} = props ?? {};

          return  prontuariosControllerCancelar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProntuariosControllerCancelarMutationResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerCancelar>>>
    export type ProntuariosControllerCancelarMutationBody = CancelarProntuarioDto
    export type ProntuariosControllerCancelarMutationError = ErroResponse

    /**
 * @summary Cancela o prontuário (engano: paciente errado, duplicado). Continua visível, com motivo, autor e data; deixa de aceitar anexo e não conta mais como o mais recente.
 */
export const useProntuariosControllerCancelar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerCancelar>>, TError,{id: string;data: CancelarProntuarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prontuariosControllerCancelar>>,
        TError,
        {id: string;data: CancelarProntuarioDto},
        TContext
      > => {
      return useMutation(getProntuariosControllerCancelarMutationOptions(options), queryClient);
    }
    export const getProntuariosControllerAnexosUrl = (id: string,) => {




  return `/v1/prontuarios/${id}/anexos`
}

/**
 * @summary Anexos — append-only, do mais antigo pro mais recente, com arquivos e exames.
 */
export const prontuariosControllerAnexos = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ListaDeAnexosResponse> => {

  return httpClient<ListaDeAnexosResponse>(getProntuariosControllerAnexosUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProntuariosControllerAnexosQueryKey = (id: string,) => {
    return [
    `/v1/prontuarios/${id}/anexos`
    ] as const;
    }


export const getProntuariosControllerAnexosQueryOptions = <TData = Awaited<ReturnType<typeof prontuariosControllerAnexos>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerAnexos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProntuariosControllerAnexosQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof prontuariosControllerAnexos>>> = ({ signal }) => prontuariosControllerAnexos(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerAnexos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProntuariosControllerAnexosQueryResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerAnexos>>>
export type ProntuariosControllerAnexosQueryError = unknown


export function useProntuariosControllerAnexos<TData = Awaited<ReturnType<typeof prontuariosControllerAnexos>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerAnexos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof prontuariosControllerAnexos>>,
          TError,
          Awaited<ReturnType<typeof prontuariosControllerAnexos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProntuariosControllerAnexos<TData = Awaited<ReturnType<typeof prontuariosControllerAnexos>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerAnexos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof prontuariosControllerAnexos>>,
          TError,
          Awaited<ReturnType<typeof prontuariosControllerAnexos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProntuariosControllerAnexos<TData = Awaited<ReturnType<typeof prontuariosControllerAnexos>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerAnexos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Anexos — append-only, do mais antigo pro mais recente, com arquivos e exames.
 */

export function useProntuariosControllerAnexos<TData = Awaited<ReturnType<typeof prontuariosControllerAnexos>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof prontuariosControllerAnexos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProntuariosControllerAnexosQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProntuariosControllerAdicionarAnexoUrl = (id: string,) => {




  return `/v1/prontuarios/${id}/anexos`
}

/**
 * @summary Atualiza o prontuário por anexo: título + texto, fotos/PDFs, exames e/ou tratamento — tudo num envio só, gravado tudo ou nada. Nunca editável. Só o prontuário mais recente do paciente aceita.
 */
export const prontuariosControllerAdicionarAnexo = async (id: string,
    prontuariosControllerAdicionarAnexoBody: ProntuariosControllerAdicionarAnexoBody, options?: Parameters<typeof httpClient>[1]): Promise<AnexoDeProntuarioResponse> => {
    const formData = new FormData();
formData.append(`dados`, prontuariosControllerAdicionarAnexoBody.dados);
if(prontuariosControllerAdicionarAnexoBody.arquivos !== undefined) {
 prontuariosControllerAdicionarAnexoBody.arquivos.forEach(value => formData.append(`arquivos`, value));
 }

  return httpClient<AnexoDeProntuarioResponse>(getProntuariosControllerAdicionarAnexoUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getProntuariosControllerAdicionarAnexoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAdicionarAnexo>>, TError,{id: string;data: ProntuariosControllerAdicionarAnexoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAdicionarAnexo>>, TError,{id: string;data: ProntuariosControllerAdicionarAnexoBody}, TContext> => {

const mutationKey = ['prontuariosControllerAdicionarAnexo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prontuariosControllerAdicionarAnexo>>, {id: string;data: ProntuariosControllerAdicionarAnexoBody}> = (props) => {
          const {id,data} = props ?? {};

          return  prontuariosControllerAdicionarAnexo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProntuariosControllerAdicionarAnexoMutationResult = NonNullable<Awaited<ReturnType<typeof prontuariosControllerAdicionarAnexo>>>
    export type ProntuariosControllerAdicionarAnexoMutationBody = ProntuariosControllerAdicionarAnexoBody
    export type ProntuariosControllerAdicionarAnexoMutationError = ErroResponse

    /**
 * @summary Atualiza o prontuário por anexo: título + texto, fotos/PDFs, exames e/ou tratamento — tudo num envio só, gravado tudo ou nada. Nunca editável. Só o prontuário mais recente do paciente aceita.
 */
export const useProntuariosControllerAdicionarAnexo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prontuariosControllerAdicionarAnexo>>, TError,{id: string;data: ProntuariosControllerAdicionarAnexoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prontuariosControllerAdicionarAnexo>>,
        TError,
        {id: string;data: ProntuariosControllerAdicionarAnexoBody},
        TContext
      > => {
      return useMutation(getProntuariosControllerAdicionarAnexoMutationOptions(options), queryClient);
    }
